import { useState } from 'react';
import { Typography, Menu, MenuItem, ListItemText, Divider, ButtonBase, ListItemIcon } from '@mui/material';
import { SwapHoriz as CambiarIcon, AddBusiness as NuevaIcon, Check as CheckIcon } from '@mui/icons-material';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { getMeAsync } from '@/store/authSlice';
import { STORAGE } from '@/config/authConfig';

/**
 * Empresa y perfil con que la persona está trabajando. Si pertenece a varias
 * empresas, permite cambiar de una a otra (va en el header X-Empresa-Id).
 */
export default function EmpresaActiva() {
  const user = useAppSelector(s => s.auth.user);
  const dispatch = useAppDispatch();
  const qc = useQueryClient();
  const navigate = useNavigate();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  if (!user) return null;
  const empresas = user.empresasUsuario ?? [];

  const cambiar = async (empresaId: number) => {
    setAnchor(null);
    if (empresaId === user.empresaId) return;
    try { localStorage.setItem(STORAGE.EMPRESA, String(empresaId)); } catch { /* sin almacenamiento */ }
    qc.clear();
    await dispatch(getMeAsync());
    navigate('/');
  };

  return (
    <>
      <ButtonBase onClick={e => setAnchor(e.currentTarget)} sx={{ display: 'block', textAlign: 'left', width: '100%', borderRadius: 1 }}>
        <Typography variant="caption" color="text.secondary" noWrap display="block">
          {user.perfilPOS ?? user.roles?.[0] ?? 'Usuario'}{user.empresaNombre ? ` · ${user.empresaNombre}` : ''}
        </Typography>
        {empresas.length > 1 && (
          <Typography variant="caption" color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
            <CambiarIcon sx={{ fontSize: 14 }} /> Cambiar de empresa
          </Typography>
        )}
      </ButtonBase>
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
        {empresas.map(e => (
          <MenuItem key={e.empresaId} onClick={() => cambiar(e.empresaId)} selected={e.empresaId === user.empresaId}>
            <ListItemIcon>{e.empresaId === user.empresaId && <CheckIcon fontSize="small" />}</ListItemIcon>
            <ListItemText primary={e.nombre} secondary={e.perfil} />
          </MenuItem>
        ))}
        {empresas.length > 0 && <Divider />}
        <MenuItem onClick={() => { setAnchor(null); navigate('/onboarding?nueva=1'); }}>
          <ListItemIcon><NuevaIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="Crear otra empresa" />
        </MenuItem>
      </Menu>
    </>
  );
}

